import { createAction, createReducer } from 'utils/reducer';

// Local constants
const PATH = 'carriers/';
const DISABLE_ERRORS = `${PATH}DISABLE_ERRORS`;
const TOGGLE_FORM = `${PATH}TOGGLE_FORM`;
const CHANGE_CONTROLS = `${PATH}CHANGE_CONTROLS`;
const TOGGLE_DELETE = `${PATH}TOGGLE_DELETE`;
const TOGGLE_EDIT_CARRIER = `${PATH}TOGGLE_EDIT_CARRIER`;
const SET_INVALID_CONTROLS = `${PATH}SET_INVALID_CONTROLS`;

// Global constants for saga
export const CARRIERS = {
  CREATE_CARRIER: `${PATH}CREATE_CARRIER`,
  CREATE_CARRIER_SUCCESS: `${PATH}CREATE_CARRIER_SUCCESS`,
  GET_STATE_FROM_API: `${PATH}GET_STATE_FROM_API`,
  GET_STATE_FROM_API_SUCCESS: `${PATH}GET_STATE_FROM_API_SUCCESS`,
  DELETE_CARRIER: `${PATH}DELETE_CARRIER`,
  DELETE_CARRIER_SUCCESS: `${PATH}DELETE_CARRIER_SUCCESS`,
  DELETE_CARRIER_FAIL: `${PATH}DELETE_CARRIER_FAIL`,
  EDIT_CARRIER_SUCCESS: `${PATH}EDIT_CARRIER_SUCCESS`,
  EDIT_CARRIER: `${PATH}EDIT_CARRIER`,
};

// actions
export const carriersActions = {
  disableErrors: createAction(DISABLE_ERRORS),
  toggleForm: createAction(TOGGLE_FORM, 'modal'),
  changeControls: createAction(CHANGE_CONTROLS, 'controls', 'invalidControls'),
  toggleDelete: createAction(TOGGLE_DELETE, 'id'),
  toggleEdit: createAction(TOGGLE_EDIT_CARRIER, 'item'),
  setInvalidControls: createAction(SET_INVALID_CONTROLS, 'controls'),
  // api
  getStateFromApi: createAction(CARRIERS.GET_STATE_FROM_API),
  createCarrier: createAction(CARRIERS.CREATE_CARRIER, 'controls'),
  editCarrier: createAction(CARRIERS.EDIT_CARRIER, 'id', 'controls'),
  deleteCarrier: createAction(CARRIERS.DELETE_CARRIER, 'id'),
};

const defaultInvalidInputs = {
  name: false,
};

const initialState = {
  formControls: {
    name: '',
  },
  invalidControls: {
    name: false,
  },
  formIsOpen: false,
  deleteIsOpen: false,
  toDeleteId: '',
  toEditId: '',
  edit: false,
  error: false,
};

const carriers = createReducer(initialState, {
  [DISABLE_ERRORS](state, action) {
    state.error = false;
  },
  [TOGGLE_FORM](state, action) {
    state[action.modal] = !state[action.modal];
    state.edit = false;
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CHANGE_CONTROLS](state, action) {
    state.formControls = {
      ...state.formControls,
      ...action.controls,
    };
    state.invalidControls = {
      ...state.invalidControls,
      ...(action.invalidControls || {}),
    };
  },
  [TOGGLE_DELETE](state, action) {
    state.deleteIsOpen = !state.deleteIsOpen;
    state.toDeleteId = action.id;
  },
  [TOGGLE_EDIT_CARRIER](state, action) {
    state.formIsOpen = true;
    state.toDeleteId = '';
    state.toEditId = action.item.id;
    state.formControls.name = action.item.name;
    state.edit = true;
  },
  [SET_INVALID_CONTROLS](state, action) {
    state.invalidControls = {
      ...state.invalidControls,
      ...action.controls,
    };
  },
  // api
  [CARRIERS.CREATE_CARRIER_SUCCESS](state, action) {
    state.formIsOpen = false;
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
  },
  [CARRIERS.DELETE_CARRIER_SUCCESS](state, action) {
    state.deleteIsOpen = false;
    state.toDeleteId = '';
  },
  [CARRIERS.EDIT_CARRIER_SUCCESS](state, action) {
    state.formControls.name = '';
    state.invalidControls = { ...defaultInvalidInputs };
    state.formIsOpen = false;
    state.toDeleteId = '';
    state.toEditId = '';
    state.edit = false;
  },
});

export default carriers;
